import { GET_ALL_ACTIVITIES, SET_JOB_ID, SET_UNITS, SET_CUSTOM_FIELDS, SET_ACCESS_TOKEN, SET_ACTIVITY_DROPDOWN_PARAMS, SET_CUSTOM_COMPONENTS, SET_ACTIVITY_PERFORMANCE_TABLE_INFO, SET_ACTIVITY_PERFORMANCE_FILE_LIST, SET_ACTIVITY, SET_JOBS, SET_PERFORMANCE_HEADER_DATA, RESET_REDUX_STATE, RESET_PERFORMANCE_STATE , RESET_ACTIVITY_PERFORMANCE_TABLE_INFO, RESET_ALL_ACTIVITIES } from "../constants";

const initState = {
  activities: [],
  customeFields: {},
  units: [],
  jobId: "",
  accessToken: "",
  activitydropdownparams: [],
  components: [],
  tableInfo: [],
  fileList: [],
  activity: [],
  jobs: [],
  performanceHeader: ''
};

const performance = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_ACTIVITIES: {
      return {
        ...state,
        activities: payload,
      };
    }

    case RESET_ALL_ACTIVITIES: {
      return {
        ...state,
        activities: [],
      }
    }

    case SET_JOB_ID: {
      return {
        ...state,
        jobId: payload,
      };
    }

    case SET_UNITS: {
      return {
        ...state,
        units: payload,
      };
    }

    case SET_CUSTOM_FIELDS: {
      return {
        ...state,
        customeFields: payload,
      };
    }

    case SET_ACCESS_TOKEN: {
      return {
        ...state,
        accessToken: payload,
      };
    }

    case SET_ACTIVITY_DROPDOWN_PARAMS: {
      return {
        ...state,
        activitydropdownparams: payload,
      };
    }
    case SET_CUSTOM_COMPONENTS: {
      return {
        ...state,
        components: payload,
      };
    }
    case SET_ACTIVITY_PERFORMANCE_TABLE_INFO: {
      return {
        ...state,
        tableInfo: payload,
      };
    }

    case RESET_ACTIVITY_PERFORMANCE_TABLE_INFO: {
      return {
        ...state,
        tableInfo: [],
      };
    }

    case SET_ACTIVITY_PERFORMANCE_FILE_LIST: {
      return {
        ...state,
        fileList: payload,
      };
    }
    case SET_ACTIVITY: {
      return {
        ...state,
        activity: payload,
      };
    }
    case SET_JOBS: {
      return {
        ...state,
        jobs: payload,
      };
    }
    case SET_PERFORMANCE_HEADER_DATA: {
      return {
        ...state,
        performanceHeader: payload
      }
    }

    case RESET_PERFORMANCE_STATE: {
      return initState
    }

    case RESET_REDUX_STATE: {
      return initState
    }

    default:
      return state;
  }
};

export default performance;
